import styled from 'styled-components';
import { AdvancedImage } from '@cloudinary/react';
import { Typography } from '../../../display/Typography';
import { MainButton } from '../../../inputs/buttons/MainButton';

export const StyledAdvancedImage = styled(AdvancedImage)`
  max-height: 50vh;
  width: 100%;
  object-fit: contain;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.xs}rem;
`;

export const StyledTypography = styled(Typography)`
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  margin: ${({ theme }) => theme.spaces.xs}rem 0;
`;

export const ButtonStyled = styled(MainButton)`
  margin-top: ${({ theme }) => theme.spaces.s}rem;
  align-self: flex-start;
`;

// ─── Bloque «Dónde se hizo» (spec fotos geolocalizadas § 16) ─────────────────

export const LocationSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.xxs}rem;
  margin-top: ${({ theme }) => theme.spaces.xs}rem;
  padding-top: ${({ theme }) => theme.spaces.xs}rem;
  border-top: 1px solid ${({ theme }) => theme.colors.greyVeryLight};
`;

/** Igual que la leyenda «Calidad de descarga» (CloudinaryQualitySelector). */
export const LocationTitle = styled.h3`
  margin: 0;
  font-size: 1.4rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black};
`;

export const LocationMap = styled.div`
  /* Alto fijo: el MapComponent ocupa el 100 % de su caja. */
  height: 18rem;
  width: 100%;
  margin: ${({ theme }) => theme.spaces.xxs}rem 0;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  overflow: hidden;
`;

export const MapsLink = styled.a`
  align-self: flex-start;
  color: ${({ theme }) => theme.colors.garnet};
  font-size: ${({ theme }) => theme.fontSize.S};
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  text-decoration: underline;
  /* Área táctil: se pulsa con el dedo en la tablet. */
  padding: ${({ theme }) => theme.spaces.xxs}rem 0;
`;
